<template>
  <div class="channel-list">
    <!-- 搜索表单 -->
    <el-card class="search-card">
      <el-form :model="searchForm" ref="searchForm" :inline="true" class="search-form">
        <el-form-item label="自定义检索">
          <el-select 
            v-model="searchForm.searchType" 
            placeholder="请选择检索类型" 
            style="width: 130px"
            @change="handleSearchTypeChange"
          >
            <el-option label="按工号查询" value="0"></el-option>
            <el-option label="按渠道名称" value="1"></el-option>
            <el-option label="按手机号" value="2"></el-option>
            <el-option label="按注册时间" value="3"></el-option>
            <el-option label="按平台名称" value="4"></el-option>
            <el-option label="按渠道类型" value="5"></el-option>
            <el-option label="按用户名" value="6"></el-option>
          </el-select>
        </el-form-item>

        <!-- 按工号查询 -->
        <el-form-item v-if="searchForm.searchType === '0'" prop="alias">
          <el-input
            v-model="searchForm.alias"
            placeholder="工号"
            clearable
            style="width: 140px"
          />
          <span style="margin-left: 10px;">显示层级关系：</span>
          <el-radio-group v-model="searchForm.showHierarchy" style="margin-left: 5px;">
            <el-radio :label="false">否</el-radio>
            <el-radio :label="true">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 按渠道名称查询 -->
        <el-form-item v-if="searchForm.searchType === '1'" prop="channelName">
          <el-input
            v-model="searchForm.channelName"
            placeholder="渠道名称"
            clearable
            style="width: 140px"
          />
          <span style="margin-left: 10px;">按渠道名称的字典排序：</span>
          <el-radio-group v-model="searchForm.nameSort" style="margin-left: 5px;">
            <el-radio label="desc">倒序</el-radio>
            <el-radio label="asc">正序</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 按手机号查询 -->
        <el-form-item v-if="searchForm.searchType === '2'" prop="mobile">
          <el-input
            v-model="searchForm.mobile"
            placeholder="手机号码"
            maxlength="11"
            clearable
            style="width: 140px"
          />
        </el-form-item>

        <!-- 按注册时间查询 -->
        <el-form-item v-if="searchForm.searchType === '3'">
          <span>开始时间：</span>
          <el-date-picker
            v-model="searchForm.beginTime"
            type="date"
            placeholder="开始时间"
            style="width: 110px; margin-left: 5px; margin-right: 10px;"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
          <span>结束时间：</span>
          <el-date-picker
            v-model="searchForm.endTime"
            type="date"
            placeholder="结束时间"
            style="width: 110px; margin-left: 5px; margin-right: 10px;"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
          <span>按渠道名称的字典排序：</span>
          <el-radio-group v-model="searchForm.timeSort" style="margin-left: 5px;">
            <el-radio label="desc">倒序</el-radio>
            <el-radio label="asc">正序</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 按平台名称查询 -->
        <el-form-item v-if="searchForm.searchType === '4'" prop="appType">
          <el-select
            v-model="searchForm.appType"
            placeholder="请选择平台"
            style="width: 160px"
          >
            <el-option label="睿保物流" value="1"></el-option>
            <el-option label="安心保" value="2"></el-option>
            <el-option label="其他平台" value="3"></el-option>
          </el-select>
          <span style="margin-left: 10px;">按渠道名称的字典排序：</span>
          <el-radio-group v-model="searchForm.appSort" style="margin-left: 5px;">
            <el-radio label="desc">倒序</el-radio>
            <el-radio label="asc">正序</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 按渠道类型查询 -->
        <el-form-item v-if="searchForm.searchType === '5'" prop="channelType">
          <el-select
            v-model="searchForm.channelType"
            placeholder="请选择类型"
            style="width: 130px"
          >
            <el-option label="代理人" value="1"></el-option>
            <el-option label="机构" value="2"></el-option>
          </el-select>
          <span style="margin-left: 10px;">按渠道名称的字典排序：</span>
          <el-radio-group v-model="searchForm.typeSort" style="margin-left: 5px;">
            <el-radio label="desc">倒序</el-radio>
            <el-radio label="asc">正序</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 按用户名查询 -->
        <el-form-item v-if="searchForm.searchType === '6'" prop="username">
          <el-input
            v-model="searchForm.username"
            placeholder="用户名"
            clearable
            style="width: 140px"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleShowAll">全部</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 操作按钮 -->
    <el-card class="operation-card">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
      <el-button type="success" icon="el-icon-download" @click="handleExport">导出Excel</el-button>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card">
      <el-table
        ref="channelTable"
        :data="tableData"
        v-loading="loading"
        border
        stripe
        row-key="id"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :default-expand-all="false"
        style="width: 100%"
      >
        <el-table-column prop="realname" label="名称" width="200" />
        <el-table-column prop="top_channel_name" label="顶级渠道名称" width="150" align="center" />
        <el-table-column prop="type" label="代理类型" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.type === 1 ? '代理人' : scope.row.type === 2 ? '机构' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="100" align="center" />
        <el-table-column prop="app_id" label="平台名称" width="280" align="center">
          <template slot-scope="scope">
            {{ getAppName(scope.row.app_id) }}
          </template>
        </el-table-column>
        <el-table-column prop="alias" label="工号" width="100" align="center" />
        <el-table-column prop="username" label="用户名" width="240" align="center" />
        <el-table-column prop="mobile" label="手机号" width="240" align="center" />
        <el-table-column prop="pcUrl" label="PC端专属链接(双击即可复制)" width="360" align="center">
          <template slot-scope="scope">
            <span 
              @dblclick="copyToClipboard(getPcUrl(scope.row))" 
              style="cursor: pointer; color: #409EFF;"
              :title="getPcUrl(scope.row)"
            >
              {{ getPcUrl(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mobileUrl" label="移动端h5专属链接(双击即可复制)" width="600" align="center">
          <template slot-scope="scope">
            <span 
              @dblclick="copyToClipboard(getMobileUrl(scope.row))" 
              style="cursor: pointer; color: #409EFF;"
              :title="getMobileUrl(scope.row)"
            >
              {{ getMobileUrl(scope.row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" width="200" align="center">
          <template slot-scope="scope">
            {{ getFullAddress(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" width="240" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="disabled" label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
              {{ scope.row.disabled ? '禁用' : '启用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.row)" title="编辑">
              <i class="el-icon-edit"></i>
            </el-button>
            <el-button type="text" size="mini" @click="handleView(scope.row)" title="查看">
              <i class="el-icon-view"></i>
            </el-button>
            <!-- <el-button type="text" size="mini" @click="handleChannelRegion(scope.row)" title="投保区域">
              投保区域
            </el-button> -->
            <el-button type="text" size="mini" @click="handleCustomization(scope.row)" title="定制工号">
              定制工号
            </el-button>
            <el-button 
              type="text" 
              size="mini" 
              @click="handleToggleStatus(scope.row)"
              :style="{ color: scope.row.disabled ? 'green' : 'red' }"
            >
              {{ scope.row.disabled ? '启用' : '禁用' }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleNote(scope.row)">
              备注
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="!searchForm.showHierarchy">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 15, 20]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="800px"
      @close="handleDialogClose"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="channelForm"
        label-width="120px"
      >
        <el-row :gutter="20">
           <el-col :span="12">
             <el-form-item label="渠道名称" prop="realname">
               <el-input 
                 v-model="formData.realname" 
                 placeholder="请输入渠道名称"
               />
             </el-form-item>
           </el-col>
           <el-col :span="12" v-if="isEdit">
             <el-form-item label="工号" prop="alias">
               <el-input 
                 v-model="formData.alias" 
                 placeholder="请输入工号" 
                 disabled
               />
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="20">
           <el-col :span="12">
             <el-form-item label="用户名" prop="username">
               <el-input 
                 v-model="formData.username" 
                 placeholder="请输入用户名" 

               />
             </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="手机号" prop="mobile">
               <el-input 
                 v-model="formData.mobile" 
                 placeholder="请输入手机号" 

               />
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="20">
           <el-col :span="12">
             <el-form-item label="密码" prop="password">
               <el-input 
                 v-model="formData.password" 
                 type="password" 
                 placeholder="请输入密码" 
                 show-password 

               />
             </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="邮箱" prop="email">
               <el-input 
                 v-model="formData.email" 
                 placeholder="请输入邮箱" 

               />
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="20">
           <el-col :span="12">
             <el-form-item label="代理类型" prop="type">
               <el-select 
                 v-model="formData.type" 
                 placeholder="请选择代理类型" 
                 style="width: 100%"

               >
                 <el-option label="代理人" :value="1" />
                 <el-option label="机构" :value="2" />
               </el-select>
             </el-form-item>
           </el-col>
           <el-col :span="12">
             <el-form-item label="平台" prop="appId">
               <el-autocomplete
                 v-model="formData.appName"
                 :fetch-suggestions="queryApps"
                 placeholder="请输入平台名称搜索"
                 style="width: 100%"
                 @select="handleAppSelect"
                 clearable

               />
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="20">
           <el-col :span="24">
             <el-form-item label="选择渠道" prop="channelType">
               <el-radio-group 
                 v-model="formData.channelType" 
                 @change="handleChannelTypeChange"

               >
                 <el-radio :label="true">顶级渠道</el-radio>
                 <el-radio :label="false">上级渠道</el-radio>
               </el-radio-group>
               <span style="color: #999; font-size: 12px; margin-left: 10px;">注：括号里面为工号</span>
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="20" v-if="!formData.channelType">
           <el-col :span="24">
             <el-form-item label="选择上级渠道" prop="parentChannel">
               <el-autocomplete
                 v-model="formData.parentChannel"
                 :fetch-suggestions="queryParentChannels"
                 placeholder="请输入关键字搜索上级渠道"
                 style="width: 100%"
                 @select="handleParentChannelSelect"
                 clearable

               />
             </el-form-item>
           </el-col>
         </el-row>
         <el-row :gutter="20">
           <el-col :span="8">
             <el-form-item label="省份" prop="province">
               <el-autocomplete
                 v-model="formData.province"
                 :fetch-suggestions="queryProvinces"
                 placeholder="请输入省份"
                 style="width: 100%"
                 @select="handleProvinceSelect"
                 clearable

               />
             </el-form-item>
           </el-col>
           <el-col :span="8">
             <el-form-item label="城市" prop="city">
               <el-autocomplete
                 v-model="formData.city"
                 :fetch-suggestions="queryCities"
                 placeholder="请输入城市"
                 style="width: 100%"
                 @select="handleCitySelect"
                 clearable
                 :disabled="!formData.province || isEdit"
               />
             </el-form-item>
           </el-col>
         </el-row>
         <el-form-item label="详细地址" prop="address">
           <el-input 
             v-model="formData.address" 
             placeholder="请输入详细地址"
           />
         </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input 
            v-model="formData.note" 
            type="textarea" 
            :rows="3" 
            placeholder="请输入备注信息" 
          />
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-radio-group v-model="formData.disabled">
            <el-radio :label="false">启用</el-radio>
            <el-radio :label="true">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 定制工号对话框 -->
    <el-dialog
      title="定制工号"
      :visible.sync="customizationVisible"
      width="400px"
    >
      <el-form :model="customizationForm" ref="customizationForm" label-width="80px">
        <el-form-item label="新工号" prop="newAlias">
          <el-input v-model="customizationForm.newAlias" placeholder="请输入新工号" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customizationVisible = false">取消</el-button>
        <el-button type="primary" @click="handleCustomizationSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ChannelList',
  data() {
    return {
      loading: false,
      submitLoading: false,
      dialogVisible: false,
      customizationVisible: false,
      isEdit: false,
      searchForm: {
        searchType: '0', // 默认按工号查询
        alias: '',
        channelName: '',
        mobile: '',
        beginTime: '',
        endTime: '',
        appType: '',
        channelType: '',
        username: '',
        showHierarchy: false,
        nameSort: '',
        timeSort: '',
        appSort: '',
        typeSort: ''
      },
      formData: {
        id: null,
        realname: '',
        alias: '',
        username: '',
        password: '',
        mobile: '',
        email: '',
        type: 1,
        appId: 1,
        appName: '', // 平台名称，用于autocomplete显示
        channelType: true, // true为顶级渠道，false为上级渠道
        parentChannel: '',
        parentId: 0,
        province: '',
        city: '',
        district: '',
        address: '',
        note: '',
        disabled: false
      },
      customizationForm: {
        userId: null,
        newAlias: ''
      },
      formRules: {
        realname: [
          { required: true, message: '请输入渠道名称', trigger: 'blur' }
        ],
        alias: [
          { 
            validator: (rule, value, callback) => {
              // 编辑模式下工号是必填的，新增模式下不需要
              if (this.isEdit && !value) {
                callback(new Error('请输入工号'))
              } else {
                callback()
              }
            }, 
            trigger: 'blur' 
          }
        ],
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于6位', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择代理类型', trigger: 'change' }
        ],
        appId: [
          { 
            validator: (rule, value, callback) => {
              if (!this.formData.appName || !this.formData.appId) {
                callback(new Error('请选择平台'))
              } else {
                callback()
              }
            }, 
            trigger: 'change' 
          }
        ]
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      provinceList: [], // 省份列表
      cityList: [], // 城市列表
      appList: [] // 应用列表
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? '编辑渠道' : '新增渠道'
    }
  },
  async mounted() {
    await this.loadAppList()
    await this.loadProvinceList()
    this.fetchData()
  },
  methods: {
    // 加载应用列表
    async loadAppList() {
      try {
        const res = await this.$api.channel.getAppList()
        if (res && res.err_code === 0) {
          this.appList = res.rows || []
        }
      } catch (error) {
        console.error('获取应用列表失败:', error)
      }
    },

    // 加载省份列表
    async loadProvinceList() {
      try {
        console.log('开始加载省份列表...')
        const res = await this.$api.channel.getProvinceList()
        console.log('省份接口响应:', res)
        
        if (res && res.err_code === 0) {
          this.provinceList = res.rows || []
          console.log('省份列表加载成功:', this.provinceList.length, '个省份')
        } else {
          console.error('省份接口返回错误:', res)
          this.$message.error('获取省份列表失败: ' + (res?.err_msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取省份列表失败:', error)
        this.$message.error('获取省份列表失败，请检查网络连接')
      }
    },

    // 加载城市列表
    async loadCityList(province) {
      if (!province) {
        this.cityList = []
        return
      }
      try {
        console.log('开始加载城市列表，省份:', province)
        const res = await this.$api.channel.getCityList({ province })
        console.log('城市接口响应:', res)
        
        if (res && res.err_code === 0) {
          this.cityList = res.rows || []
          console.log('城市列表加载成功:', this.cityList.length, '个城市')
        } else {
          console.error('城市接口返回错误:', res)
          this.$message.error('获取城市列表失败: ' + (res?.err_msg || '未知错误'))
        }
      } catch (error) {
        console.error('获取城市列表失败:', error)
        this.$message.error('获取城市列表失败，请检查网络连接')
      }
    },

    // 省份模糊查询
    queryProvinces(queryString, cb) {
      console.log('省份模糊查询:', queryString, '省份列表长度:', this.provinceList.length)
      
      if (this.provinceList.length === 0) {
        console.warn('省份列表为空，尝试重新加载')
        this.loadProvinceList()
        cb([])
        return
      }
      
      let results = this.provinceList.map(item => ({
        value: item.province,
        province: item.province
      }))
      
      if (queryString) {
        results = results.filter(item => 
          item.value.toLowerCase().includes(queryString.toLowerCase())
        )
      }
      
      console.log('省份查询结果:', results.length, '个匹配项')
      cb(results)
    },

    // 城市模糊查询
    queryCities(queryString, cb) {
      console.log('城市模糊查询:', queryString, '城市列表长度:', this.cityList.length)
      
      if (this.cityList.length === 0) {
        console.warn('城市列表为空')
        cb([])
        return
      }
      
      let results = this.cityList.map(item => ({
        value: item.city,
        city: item.city,
        city_code: item.city_code,
        id: item.id,
        province: item.province
      }))
      
      if (queryString) {
        results = results.filter(item => 
          item.value.toLowerCase().includes(queryString.toLowerCase())
        )
      }
      
      console.log('城市查询结果:', results.length, '个匹配项')
      cb(results)
    },

    // 省份选择事件
    handleProvinceSelect(item) {
      this.formData.province = item.value
      this.formData.city = '' // 清空城市
      this.loadCityList(item.value)
    },

    // 城市选择事件
    handleCitySelect(item) {
      console.log('选择城市:', item)
      this.formData.city = item.value
    },

    // 渠道类型变化事件
    handleChannelTypeChange(value) {
      if (value) {
        // 选择顶级渠道时，清空上级渠道相关信息
        this.formData.parentChannel = ''
        this.formData.parentId = 0
      }
    },

    // 查询上级渠道
    async queryParentChannels(queryString, cb) {
      try {
        // 使用正确的接口和参数，参考老项目实现
        const params = {
          app_id: this.formData.appId || 1 // 传递当前渠道的app_id
        }
        
        // 使用与老项目一致的接口
        const res = await this.$api.channel.getChannelList(params)
        if (res && res.err_code === 0 && res.rows) {
          let results = res.rows
            .filter(item => {
              // 排除自己
              if (item.id === this.formData.id) return false
              return true
            })
            .map(item => ({
              value: `${item.realname}(${item.alias})`,
              id: item.id,
              realname: item.realname,
              alias: item.alias
            }))
          
          // 如果有查询字符串，进行过滤
          if (queryString) {
            results = results.filter(item => {
              const searchText = `${item.realname || ''}${item.alias || ''}`.toLowerCase()
              return searchText.includes(queryString.toLowerCase())
            })
          }
          
          cb(results)
        } else {
          cb([])
        }
      } catch (error) {
        console.error('获取上级渠道列表失败:', error)
        cb([])
      }
    },

    // 上级渠道选择事件
    handleParentChannelSelect(item) {
      this.formData.parentChannel = item.value
      this.formData.parentId = item.id
    },

    // 查询平台
    queryApps(queryString, cb) {
      if (!this.appList || this.appList.length === 0) {
        cb([])
        return
      }
      
      let results = this.appList.map(app => ({
        value: app.name,
        id: app.id,
        name: app.name
      }))
      
      if (queryString) {
        results = results.filter(item => 
          item.value.toLowerCase().includes(queryString.toLowerCase())
        )
      }
      
      cb(results)
    },

    // 平台选择事件
    handleAppSelect(item) {
      this.formData.appName = item.value
      this.formData.appId = item.id
    },

    // 获取数据
    async fetchData() {
      this.loading = true
      const params = {
        page: this.pagination.currentPage,
        rows: this.pagination.pageSize,
        ...this.buildSearchParams()
      }

      try {
        const res = await this.$api.channel.getChannelGeneralList(params)
        if (res && res.err_code === 0) {
          this.tableData = res.rows || []
          this.pagination.total = res.total || 0
          
          // 处理层级关系显示
          if (this.searchForm.searchType === '0' && this.searchForm.showHierarchy) {
            this.tableData = this.convertToTree(this.tableData)
          }
        } else {
          this.$message.error(res?.err_msg || '获取数据失败')
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 转换为树形结构
    convertToTree(data) {
      const map = {}
      const roots = []
      
      // 创建映射
      data.forEach(item => {
        map[item.id] = { ...item, children: [] }
      })
      
      // 构建树形结构
      data.forEach(item => {
        if (item.parentId && map[item.parentId]) {
          map[item.parentId].children.push(map[item.id])
        } else {
          roots.push(map[item.id])
        }
      })
      
      return roots
    },

    // 扁平化树形数据
    flattenTreeData(data) {
      const result = []
      const flatten = (items) => {
        items.forEach(item => {
          const { children, ...rest } = item
          result.push(rest)
          if (children && children.length > 0) {
            flatten(children)
          }
        })
      }
      flatten(data)
      return result
    },

    // 搜索类型切换
    handleSearchTypeChange() {
      // 清空其他搜索条件
      this.searchForm.alias = ''
      this.searchForm.channelName = ''
      this.searchForm.mobile = ''
      this.searchForm.beginTime = ''
      this.searchForm.endTime = ''
      this.searchForm.appType = ''
      this.searchForm.channelType = ''
      this.searchForm.username = ''
      this.searchForm.showHierarchy = false
      this.searchForm.nameSort = ''
      this.searchForm.timeSort = ''
      this.searchForm.appSort = ''
      this.searchForm.typeSort = ''
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 显示全部
    handleShowAll() {
      this.$refs.searchForm.resetFields()
      this.searchForm.searchType = '0'
      this.pagination.currentPage = 1
      this.fetchData()
    },

    // 新增
    handleAdd() {
      this.isEdit = false
      this.formData = {
        id: null,
        realname: '',
        alias: '',
        username: '',
        password: '',
        mobile: '',
        email: '',
        type: 1,
        appId: 1,
        appName: this.getAppName(1),
        channelType: true,
        parentChannel: '',
        parentId: 0,
        province: '',
        city: '',
        district: '',
        address: '',
        note: '',
        disabled: false
      }
      this.dialogVisible = true
    },

    // 编辑
    async handleEdit(row) {
      this.isEdit = true
      
      // 先加载省份列表
      await this.loadProvinceList()
      
      try {
        // 调用接口获取渠道详细信息
        const res = await this.$api.channel.getChannelInfo({ id: row.id })
        if (res && res.err_code === 0) {
          const channelInfo = res.data || {}
          const appId = channelInfo.app_id || row.app_id || 1
          this.formData = {
            id: channelInfo.id || row.id,
            realname: channelInfo.realname || row.realname || '',
            alias: channelInfo.alias || row.alias || '',
            username: channelInfo.username || row.username || '',
            password: channelInfo.login_password || '',
            mobile: channelInfo.mobile || row.mobile || '',
            email: channelInfo.email || '',
            type: channelInfo.type || row.type || 1,
            appId: appId,
            appName: this.getAppName(appId),
            channelType: (channelInfo.parent_id || row.parent_id || 0) === 0,
            parentChannel: '',
            parentId: channelInfo.parent_id || row.parent_id || 0,
            province: channelInfo.province || row.province || '',
            city: channelInfo.city || row.city || '',
            district: channelInfo.district || row.district || '',
            address: channelInfo.address || row.address || '',
            note: channelInfo.note || '',
            disabled: channelInfo.disabled !== undefined ? channelInfo.disabled : (row.disabled || false)
          }
          
          // 如果有上级渠道，获取上级渠道信息
          if (this.formData.parentId && this.formData.parentId > 0) {
            try {
              const parentRes = await this.$api.channel.getChannelInfo({ id: this.formData.parentId })
              if (parentRes && parentRes.err_code === 0 && parentRes.data) {
                const parentInfo = parentRes.data
                this.formData.parentChannel = `${parentInfo.channel_name}(${parentInfo.alias})`
              } else {
                // 如果获取上级渠道信息失败，使用ID作为显示
                this.formData.parentChannel = `上级渠道(${this.formData.parentId})`
              }
            } catch (error) {
              console.error('获取上级渠道信息失败:', error)
              this.formData.parentChannel = `上级渠道(${this.formData.parentId})`
            }
          }
          
          // 如果有省份信息，加载对应的城市列表
          if (this.formData.province) {
            await this.loadCityList(this.formData.province)
          }
        } else {
          this.$message.error(res?.err_msg || '获取渠道信息失败')
          // 如果接口失败，使用传入的row数据
          const appId = row.app_id || 1
          this.formData = {
            id: row.id,
            realname: row.realname || '',
            alias: row.alias || '',
            username: row.username || '',
            password: '',
            mobile: row.mobile || '',
            email: row.email || '',
            type: row.type || 1,
            appId: appId,
            appName: this.getAppName(appId),
            channelType: (row.parent_id || 0) === 0,
            parentChannel: '',
            parentId: row.parent_id || 0,
            province: row.province || '',
            city: row.city || '',
            district: row.district || '',
            address: row.address || '',
            note: row.note || '',
            disabled: row.disabled || false
          }
        }
      } catch (error) {
        console.error('获取渠道信息失败:', error)
        this.$message.error('获取渠道信息失败')
        // 如果接口失败，使用传入的row数据
        const appId = row.app_id || 1
        this.formData = {
          id: row.id,
          realname: row.realname || '',
          alias: row.alias || '',
          username: row.username || '',
          password: '',
          mobile: row.mobile || '',
          email: row.email || '',
          type: row.type || 1,
          appId: appId,
          appName: this.getAppName(appId),
          channelType: (row.parent_id || 0) === 0,
          parentChannel: '',
          parentId: row.parent_id || 0,
          province: row.province || '',
          city: row.city || '',
          district: row.district || '',
          address: row.address || '',
          note: row.note || '',
          disabled: row.disabled || false
        }
      }
      
      this.dialogVisible = true
    },

    // 查看
    handleView(row) {
      this.isEdit = true
      this.formData = { ...row }
      this.dialogVisible = true
      // 设置表单为只读状态
      this.$nextTick(() => {
        const formItems = this.$refs.channelForm.$el.querySelectorAll('.el-input__inner, .el-select, .el-radio')
        formItems.forEach(item => {
          item.disabled = true
        })
      })
    },

    // 投保区域
    handleChannelRegion(row) {
      // TODO: 打开投保区域页面
      this.$message.info(`打开渠道${row.id}的投保区域管理`)
    },

    // 定制工号
    handleCustomization(row) {
      this.customizationForm.userId = row.id
      this.customizationForm.newAlias = ''
      this.customizationVisible = true
    },

    // 定制工号提交
    async handleCustomizationSubmit() {
      if (!this.customizationForm.newAlias) {
        this.$message.warning('请输入新工号')
        return
      }
      
      try {
        const res = await this.$api.channel.customizeChannelAlias({
          id: this.customizationForm.userId,
          alias: this.customizationForm.newAlias
        })
        
        if (res && res.err_code === 0) {
          this.$message.success('工号定制成功')
          this.customizationVisible = false
          this.fetchData()
        } else {
          this.$message.error(res?.err_msg || '工号定制失败')
        }
      } catch (error) {
        console.error('定制工号失败:', error)
        this.$message.error('工号定制失败')
      }
    },

    // 启用/禁用
    async handleToggleStatus(row) {
      const action = row.disabled ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${action}该渠道吗？`, '提示', { type: 'warning' })
        
        const res = await this.$api.channel.toggleChannelStatus({
          id: row.id,
          disabled: !row.disabled
        })
        
        if (res && res.err_code === 0) {
          row.disabled = !row.disabled
          this.$message.success(`${action}成功`)
        } else {
          this.$message.error(res?.err_msg || `${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(`${action}失败`)
        }
      }
    },

    // 备注
    handleNote(row) {
      this.$router.push({
        name: 'channelNoteList',
        query: { id: row.id }
      })
    },

    // 导出Excel
    async handleExport() {
      // TODO: 等待后端提供导出接口
      this.$message.info('导出功能开发中，请稍后...')
      
      // try {
      //   this.loading = true
      //   const params = this.buildSearchParams()
      //   
      //   const res = await this.$api.channel.exportChannelList(params)
      //   
      //   if (res && res.err_code === 0) {
      //     // 创建下载链接
      //     const link = document.createElement('a')
      //     link.href = res.download_url
      //     link.download = `渠道列表_${new Date().toISOString().slice(0, 10)}.xlsx`
      //     document.body.appendChild(link)
      //     link.click()
      //     document.body.removeChild(link)
      //     
      //     this.$message.success('导出成功')
      //   } else {
      //     this.$message.error(res?.err_msg || '导出失败')
      //   }
      // } catch (error) {
      //   console.error('导出失败:', error)
      //   this.$message.error('导出失败')
      // } finally {
      //   this.loading = false
      // }
    },

    // 构建搜索参数
    buildSearchParams() {
      const params = {}
      
      if (this.searchForm.searchType) {
        switch (this.searchForm.searchType) {
          case '0': // 按工号
            if (this.searchForm.alias) {
              params.alias = this.searchForm.alias
              params.show_hierarchy = this.searchForm.showHierarchy
            }
            break
          case '1': // 按渠道名称
            if (this.searchForm.channelName) {
              params.channel_name = this.searchForm.channelName
            }
            if (this.searchForm.nameSort) {
              params.order_field = 'realname'
              params.sort = this.searchForm.nameSort
            }
            break
          case '2': // 按手机号
            if (this.searchForm.mobile) {
              params.mobile = this.searchForm.mobile
            }
            break
          case '3': // 按注册时间
            if (this.searchForm.beginTime) {
              params.begin_date = Math.floor(new Date(this.searchForm.beginTime + ' 00:00:00').getTime() / 1000)
            }
            if (this.searchForm.endTime) {
              params.end_date = Math.floor(new Date(this.searchForm.endTime + ' 23:59:59').getTime() / 1000)
            }
            if (this.searchForm.timeSort) {
              params.order_field = 'realname'
              params.sort = this.searchForm.timeSort
            }
            break
          case '4': // 按平台名称
            if (this.searchForm.appType) {
              params.app_id = this.searchForm.appType
            }
            if (this.searchForm.appSort) {
              params.order_field = 'realname'
              params.sort = this.searchForm.appSort
            }
            break
          case '5': // 按渠道类型
            if (this.searchForm.channelType) {
              params.type = this.searchForm.channelType
            }
            if (this.searchForm.typeSort) {
              params.order_field = 'realname'
              params.sort = this.searchForm.typeSort
            }
            break
          case '6': // 按用户名
            if (this.searchForm.username) {
              params.username = this.searchForm.username
            }
            break
        }
      }
      
      return params
    },

    // 提交表单
    async handleSubmit() {
      try {
        await this.$refs.channelForm.validate()
        
        this.submitLoading = true
        
        let submitData = {}
        submitData = {
            username: this.formData.username,
            password: this.formData.password,
            app_id: this.formData.appId,
            realname: this.formData.realname,
            mobile: this.formData.mobile,
            email: this.formData.email || '',
            parent_id: this.formData.channelType ? 0 : (this.formData.parentId || 0),
            province: this.formData.province,
            city: this.formData.city,
            address: this.formData.address,
            note: this.formData.note || '',
            type: this.formData.type,
            set_top_channel: this.formData.channelType,
            disabled: this.formData.disabled ? 1 : 0
        }
        
        if (this.isEdit) {
          // 编辑模式：只提交id、note和disabled字段
          submitData.id = this.formData.id;
        }
        
        const apiMethod = this.isEdit ? 'updateChannel' : 'addChannel'
        const res = await this.$api.channel[apiMethod](submitData)
        
        if (res && res.err_code === 0) {
          this.$message.success(this.isEdit ? '编辑成功' : '新增成功')
          this.dialogVisible = false
          this.fetchData()
        } else {
          this.$message.error(res?.err_msg || (this.isEdit ? '编辑失败' : '新增失败'))
        }
      } catch (error) {
        if (error !== false) {
          console.error('提交表单失败:', error)
          this.$message.error(this.isEdit ? '编辑失败' : '新增失败')
        }
      } finally {
        this.submitLoading = false
      }
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.channelForm.resetFields()
      // 重置appName字段
      this.formData.appName = ''
    },

    // 分页
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.fetchData()
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.fetchData()
    },

    // 获取平台名称
    getAppName(appId) {
      // 如果appId为空或无效，返回空字符串
      if (!appId) return ''
      
      // 如果appList还没加载完成，返回加载中提示
      if (!this.appList || !this.appList.length) return '加载中...'
      
      try {
        // 在appList中查找匹配的应用
        const app = this.appList.find(item => 
          item.id === appId || 
          item.app_id === appId || 
          String(item.id) === String(appId) || 
          String(item.app_id) === String(appId)
        )
        
        return app ? (app.name || app.app_name || '') : `未知平台(${appId})`
      } catch (error) {
        console.error('getAppName error:', error, 'appId:', appId, 'appList:', this.appList)
        return `错误(${appId})`
      }
    },

    // 获取完整地址
    getFullAddress(row) {
      return `${row.province || ''}${row.city || ''}${row.district || ''}${row.address || ''}`
    },

    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return ''
      
      const date = new Date(dateStr)
      if (isNaN(date.getTime()) || date.getFullYear() === 1) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 获取PC端链接
    getPcUrl(row) {
      if (!row.alias) return ''
      return `www.jubao56.com/#/?alias=${row.alias}`
    },

    // 获取移动端链接
    getMobileUrl(row) {
      if (!row.alias || !row.app_id) return ''
      
      // 获取平台名称
      const appName = this.getAppNameForUrl(row.app_id)
      if (!appName) return ''
      
      // 判断是否为测试环境
      const isTestEnv = location.href.indexOf("localhost") > -1 || 
                       location.href.indexOf("test") > -1 || 
                       location.href.indexOf("127.0.0") > -1
      
      let url = ''
      if (isTestEnv) {
        if (appName === 'SuperEcargo') {
          url = `http://test.jubao56.com/ecargo/#/home?appname=${appName}&alias=${row.alias}`
        } else {
          url = `http://test.jubao56.com/m/#/review?appname=${appName}&alias=${row.alias}`
        }
      } else {
        if (appName === 'SuperEcargo') {
          url = `http://jubao.limabaoxian.com/ecargo/#/home?appname=${appName}&alias=${row.alias}`
        } else {
          url = `http://jubao.limabaoxian.com/m/#/review?appname=${appName}&alias=${row.alias}`
        }
      }
      
      return url
    },

    // 获取用于URL的平台名称
    getAppNameForUrl(appId) {
      if (!appId || !this.appList || !this.appList.length) return ''
      
      try {
        const app = this.appList.find(item => 
          item.id === appId || 
          item.app_id === appId || 
          String(item.id) === String(appId) || 
          String(item.app_id) === String(appId)
        )
        
        // 返回appname字段，这个字段用于URL生成
        return app ? (app.appname || app.app_name || '') : ''
      } catch (error) {
        console.error('getAppNameForUrl error:', error)
        return ''
      }
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.$message.error('复制失败')
        })
      } else {
        // 兼容旧浏览器
        const textArea = document.createElement('textarea')
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.select()
        try {
          document.execCommand('copy')
          this.$message.success('复制成功')
        } catch (err) {
          this.$message.error('复制失败')
        }
        document.body.removeChild(textArea)
      }
    }
  }
}
</script>

<style scoped>
.channel-list {
  padding: 20px;
}

.search-card,
.operation-card,
.table-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.search-form .el-form-item {
  margin-bottom: 10px;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

.dialog-footer {
  text-align: right;
}

.operation-card .el-button {
  margin-right: 10px;
}

/* 表格链接样式 */
.el-table .cell span[title] {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 操作按钮样式 */
.el-table .el-button--text {
  margin-right: 8px;
}
</style>
